<!-- 月到周分配结果 -->
<template>
  <ls-table-layout>
    <div class="table-page-search-wrapper" slot="search">
      <ls-search-form :formList="formList" @search="onSearch"></ls-search-form>
    </div>
    <div class="table-page-operator-wrapper" slot="btn">
      <download-modal :apiFun="apiScpMpsMonthWeekResultExport" ref="download" />
      <a-button type="primary" @click="handleExport" v-if="$hasPermi(['fun_1833472503239294978_TVDpL'])">导出</a-button>
    </div>
    <template v-slot:table>
      <div class="page-header-content">
        <ls-api-table
          ref="dataTable"
          :columns="columns"
          :tableProps="tableProps"
          rowKey="id"
          :scroll="{ fixScreen: true, x: 1300 }"
        >
          <template slot="createTime" slot-scope="{ text }">
            <span>{{ text && $moment(text).format('YYYY-MM-DD HH:mm') }}</span>
          </template>
        </ls-api-table>
      </div>
    </template>
  </ls-table-layout>
</template>

<script>
import { apiScpMpsMonthWeekResultExport, apiSelectMonthWeekResultPageList } from '@/api/finished-goods-order'
import DownloadModal from '@/views/components/download-modal/download-modal.vue'
export default {
  // eslint-disable-next-line
  name: 'Month-to-week-allocation', // name要和rms配置菜单路由保存一致(首字母大写)
  components: {
    DownloadModal
  },
  data () {
   function generateTableResData (request, serialNumberIs) {
      return params => {
        return new Promise((resolve, reject) => {
          params.pageNum = params.page;
          delete params.page;
          request(params).then(res => {
            const { total, rows, titleList } = res;
            if (serialNumberIs) {
              rows.map((item, index) => {
                item.serialNumber = (index + 1) + ((params.pageNum - 1) * params.pageSize)
              })
            }
            const { pageSize } = params
            const pages = Math.ceil(total / pageSize)
            const newRows = [];
            rows.forEach(item => {
              const row = { ...item };
              titleList.forEach(item => {
                row[item] = 0;
              })
              for(const key in item) {
                if(key.indexOf('week') === 0 && key.lastIndexOf('Date') > 0) {
                  // 用正则提取 'weekX' 部分
                  const regex = /(week\d+).*Date/;
                  const match = key.match(regex);
                  const value = match ? match[1] : null;
                  if(value && item[key]) {
                    row[item[key]] = item[value + 'Qty']
                  }
                }
              }
              newRows.push(row)
            });
            resolve({
              data: {
                state: 100,
                data: {
                  ...res,
                  records: newRows,
                  pages,
                  total
                }
              }
            })
          }).catch(err => {
            // eslint-disable-next-line prefer-promise-reject-errors
            reject({
              msg: err,
              state: 103
            })
          })
        })
      }
    }
    return {
      apiScpMpsMonthWeekResultExport,
      warehouseOptions: [],
      // 表格配置
      tableProps: {
        requestApi: generateTableResData(apiSelectMonthWeekResultPageList, true),
        pageCurrent: true,
        loadFinish: ({ response }) => {
          console.log('response:', response.data.data.titleList);
          const list = [];
          response.data.data.titleList.forEach(item => {
            list.push({
                title: item,
                dataIndex: item,
                ellipsis: true,
                width: 150,
                align: 'center'
            })
          })
          this.columns = [...this.tmpColumns1, ...list, ...this.tmpColumns2];
        }
      },
      isEdit: false,
      currentId: "",
      // 控制搜索展开
      advanced: true,
      // 查询参数
      queryParams: {
        supplierCode: undefined,
        supplierName: undefined,
        supplierClass: undefined,
        supplierAbbreviation: undefined,
        supplierBrevityCode: undefined
      },
      // 表格多选
      selectedRowKeys: [],
      selectedRows: [],
      formList: [{
        label: '周版本号',
        type: "globalSelect-selectSearch",
        decorator: ['weekPlanVersion'],
        attrs: {
          placeholder: '请选择周版本号',
          requestApi: '/scp/scpMpsSuppliesFd/findWeekVersion',
          selectItem: { value: 'selectedValue', label: 'label' },
          searchParam: 'weekPlanVersion'
        }
      },
        {
          label: '计划版本号',
          type: "globalSelect-selectSearch",
          decorator: ['version'],
          attrs: {
            placeholder: '请选择计划版本号',
            requestApi: '/scp/scpMpsSuppliesFd/findVersionList',
            selectItem: { value: 'selectedValue', label: 'label' },
            searchParam: 'version'
          }
        },
        {
        label: '工艺大类',
        type: "globalSelect-selectMultiple",
        decorator: ['productBroadCategorys'],
        attrs: {
          placeholder: '请选择工艺大类',
          requestApi: '/system/lookup/data/likeList',
          selectItem: { value: 'lookupCode', label: 'lookupValue' },
          setParams: { lookupType: 'SCP_PRODUCT_BROAD_CATEGORY', pageSize: 9999 }
        }
      },
      {
          label: '物料编码',
          type: "globalSelect-selectAssembleMultipleSearch",
          decorator: ['itemCodes'],
          attrs: {
            placeholder: '请选择物料编码',
            requestApi: '/mes/mesDiscreteJobs/assemblyBox',
            selectItem: { value: 'selectedValue', label: 'bringOutDataOne' },
            searchParam: 'itemCode'
          }
      }],
      // 表格字段
      tmpColumns1: [
        {
          title: '周版本号',
          dataIndex: 'weekPlanVersion',
          fixed: 'left',
          align: 'center',
          ellipsis: true,
          width: 140
        },
        {
          title: '计划版本号',
          width: 220,
          dataIndex: 'version',
          ellipsis: true,
          align: 'center'
        },
        {
          title: '工艺大类',
          dataIndex: 'productBroadCategory',
          ellipsis: true,
          align: 'center',
          width: 180
        },
        {
          title: '物料编码',
          dataIndex: 'itemCode',
          ellipsis: true,
          width: 150,
          align: 'center'
        },
        {
          title: '物料名称',
          dataIndex: 'itemName',
          ellipsis: true,
          width: 150,
          align: 'center'
        },
        {
          title: '供应商编码',
          dataIndex: 'supplierCode',
          ellipsis: true,
          width: 150,
          align: 'center'
        },
        {
          title: '供应商名称',
          dataIndex: 'supplierName',
          ellipsis: true,
          width: 200,
          align: 'center'
        }
      ],
      // 表格字段
      tmpColumns2: [
        {
          title: '创建人',
          dataIndex: 'createName',
          ellipsis: true,
          width: 150,
          align: 'center'
        },
        {
          title: '创建时间',
          dataIndex: 'createTime',
          scopedSlots: { customRender: 'createTime' },
          ellipsis: true,
          width: 150,
          align: 'center'
        }
      ],
      columns: [], // 表格字段
      uomClassOptions: [], // 来源分类
      unitOfMeasureList: [], // 来源单位
      unitOfMeasureListNew: [] // 基本单位
    }
  },
  created () {
    this.columns = [...this.tmpColumns1, ...this.tmpColumns2];
  },
  mounted () {
    this.onSearch()
  },
  methods: {

    // 导入导出excel
    /** 导出按钮操作 */
    handleExport () {
      // this.$nextTick(() => {
      //   const params = { ...this.queryParams }
      //   this.$refs.download.openModal(params)
      // })
      this.downloadByJson('/scp/scpMpsMonthWeekResult/export', {
        ...this.queryParams
      }, `月到周分配表_${new Date().getTime()}.xlsx`)
    },
    // 表单搜索
    onSearch (val) {
      this.queryParams = {};
      for(const key in val) {
        if(key !== 'searchFormLabel') {
          this.queryParams[key] = val[key]
        }
      }
      this.$refs.dataTable.searchParams = this.queryParams;
      this.$refs.dataTable.getData();
    },
    /** 重置按钮操作 */
    resetQuery () {
      this.queryParams = {
        uomClassList: undefined,
        unitOfMeasureList: undefined,
        baseUomList: undefined,
        status: undefined
      }
      this.onSearch()
    },
    // 搜索框展开、收起
    toggleAdvanced () {
      this.advanced = !this.advanced
    }
  }
}
</script>

<style scoped lang="less">
.ml10{
  margin-left: 10px;
}
/deep/.ant-modal-body{
  height: 400px;
  overflow-y: scroll;
}
</style>
